import { FC } from 'react';

interface CancelCircleIconProps {
  size?: number;
  title?: string;
}

export const CancelCircleIcon: FC<CancelCircleIconProps> = ({
  size = 18,
  title,
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 18 18"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    {title && <title>{title}</title>}
    <circle cx="9" cy="9" fill="#cf1520" r="9" />
    <path
      d="M13.4516 11.8609L11.8609 13.4516L9 10.5907L6.13912 13.4516L4.54838 11.8609L7.40925 9L4.54838 6.13912L6.13912 4.54838L9 7.40925L11.8609 4.54838L13.4516 6.13912L10.5907 9L13.4516 11.8609Z"
      fill="white"
    />
  </svg>
);
